module.exports = __webpack_public_path__ + "media/images/oberholzer_logo-721a0c9df4d60eca6243c335fd868a56.svg";